
import React, { useEffect } from "react";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { Col, Container, Row, Card } from "react-bootstrap";
import image from "../../assets/images/new/contact-us.png";
import ClientForm from "../../components/ClientForm/ClientForm";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  useEffect(() => {
    document.title = "Travel Enquiry";
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact a Leading Travel Agency | Shivay Tour and Travells</title>
        <meta
          name="description"
          content="Ready to plan your trip? Contact our travel agency today. Our experts are here to help you with bookings, questions, and custom tour planning."
        />
        <meta name="keywords" content="contact travel agency, tour bookings, travel planning" />

        <link rel="canonical" href="https://www.shivaytourandtravells.com/contact-us" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "TravelAgency",
            "name": "Shivay Tour and Travells",
            "url": "https://www.shivaytourandtravells.com/",
            "logo": "https://www.shivaytourandtravells.com/logo.png",
            "telephone": "+91-9876543210",
            "sameAs": [
              "https://www.facebook.com/shivaytravels",
              "https://www.instagram.com/shivaytravels",
              "https://www.twitter.com/shivaytravels"
            ],
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "123 Travel Street",
              "addressLocality": "Surat",
              "addressRegion": "GJ",
              "postalCode": "395006",
              "addressCountry": "IN"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "telephone": "+91-9876543210",
              "email": "info@shivaytourandtravells.com",
              "areaServed": "IN",
              "availableLanguage": ["English","Hindi"]
            }
          }
          `}
        </script>
      </Helmet>
      <Breadcrumbs title="Travel Enquiry" pagename="Travel Enquiry" />
      <section className="contact pt-5">
        <Container>
          <Row className="py-5 align-items-center">
            {/* Left Image */}
            <Col lg={6} className="mb-4 mb-lg-0">
              <img
                src={image}
                alt="contact us"
                className="img-fluid w-100 rounded-3 shadow"
              />
            </Col>

            {/* Right Form */}
            <Col lg={6}>
              <Card className="p-4 shadow-lg border-0 rounded-4 bg-white">
                <h2 className="text-center mb-4 text-primary fw-bold">Plan Your Travel</h2>
                <ClientForm />
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;

